import { gameState } from '../state/gameState.js';
import { showActionsModal } from './Modal.js';
import { showToast } from './Toast.js';
import { messageFor } from '../api/errors.js';
import { audioManager } from '../audio/AudioManager.js';
import { audioEvents } from '../audio/audioEvents.js';
import { animalSoundEvent, voiceEvent } from '../audio/eventMap.js';

// Open the Feed/Pet/Collect modal for an animal. At night (nightCollectOnly) only
// Collect is offered — the animal is asleep in its buda and can't be fed or petted.
export async function openAnimalActions(scene, a, opts = {}) {
  const cat = gameState.raw.catalog.animals[a.type];
  if (!cat) return;
  const n = a.pending_count ?? 0;
  const icon = cat.produces === 'jajko' ? '{egg}' : '{milk}';
  let body = `Szczęście: ${Math.round(a.happiness)}/100`;
  if (a.is_hungry) body += '\n{food} GŁODNY!';
  if (n > 0) body += `\n${icon} Gotowe do zbioru: ${n}${a.stack_max ? ` / ${a.stack_max}` : ''}`;

  const actions = [];
  if (n > 0) {
    actions.push({
      label: n >= 2 ? `Zbierz ${n} ${icon}` : `Zbierz ${icon}`,
      fn: () => { audioManager.playSfx('collect_product'); return gameState.collectProduct(a.id); },
    });
  }
  if (!opts.nightCollectOnly) {
    actions.push({ label: 'Karm', fn: () => { audioEvents.emit(voiceEvent(a.type) ?? 'place'); return gameState.feedAnimal(a.id); } });
    // Petting fills happiness to 100, only below 80 (owner 2026-09-30).
    if ((a.happiness ?? 0) < 80) actions.push({ label: 'Głaskaj', fn: () => { audioEvents.emit(animalSoundEvent('pet_animal', a.type)); opts.onPetHeart?.(); return gameState.petAnimal(a.id); } });   // farm 6: a purr / happy sounds
    else body += '\n{heart} Jest szczęśliwy';
  }
  if (opts.nightCollectOnly && n === 0) {
    body += '\n{sleep} Śpi w budzie';
  }

  const result = await showActionsModal(scene, { title: cat.name_pl, body, actions });
  if (result === null) return;
  if (result?.error) showToast(scene, messageFor(result.error));
  else showToast(scene, '{check}');
}
